import service from "@irati/utils/tracking/index";
var TRACKING_ROOT = "tour_";
var TourTracking = /** @class */ (function () {
    function TourTracking() {
        this.tourStart = function (tourName, stepCount) {
            var data = {
                tour_name: tourName,
                step_count: stepCount
            };
            service.trackTourEvent(TRACKING_ROOT + "start", data);
        };
        this.tourPrevious = function (tourName, currentStep, stepCount) {
            var data = {
                tour_name: tourName,
                current_step: currentStep,
                step_count: stepCount
            };
            service.trackTourEvent(TRACKING_ROOT + "previous", data);
        };
        this.tourNext = function (tourName, currentStep, stepCount) {
            var data = {
                tour_name: tourName,
                current_step: currentStep,
                step_count: stepCount
            };
            service.trackTourEvent(TRACKING_ROOT + "next", data);
        };
        this.tourComplete = function (tourName, stepCount) {
            var data = {
                tour_name: tourName,
                step_count: stepCount
            };
            service.trackTourEvent(TRACKING_ROOT + "complete", data);
        };
        this.tourClose = function (tourName, currentStep, stepCount) {
            var data = {
                tour_name: tourName,
                current_step: currentStep,
                step_count: stepCount
            };
            service.trackTourEvent(TRACKING_ROOT + "close", data);
        };
    }
    return TourTracking;
}());
var tourTracking = new TourTracking();
export default tourTracking;
